import { render, staticRenderFns } from "./coordinate-guide.vue?vue&type=template&id=73875344&scoped=true"
import script from "./coordinate-guide.vue?vue&type=script&lang=js"
export * from "./coordinate-guide.vue?vue&type=script&lang=js"
import style0 from "./coordinate-guide.vue?vue&type=style&index=0&id=73875344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73875344",
  null
  
)

export default component.exports